import { RISK_RATING_PRIMARIES } from "@/common/constants/controlRisks/risks";
import {
  hasPlusCyberAccess,
  hasGrdAccess,
  hasMaritimeAccess,
} from "@/services/user/user.service";
import { isFeatureUnlocked } from "@/common/featureLock.js";

export const RISK_SUMMARY_TYPE_OVERVIEW_ID =
  "788ab9a7-793e-415d-9d49-99feb0a7ec26";
export const RISK_SUMMARY_TYPE_SECURITY_RISK_ID =
  "8c66d011-cfa1-4b09-be6f-43f633efe1d7";
export const RISK_SUMMARY_TYPE_PROFILE_ID =
  "f5cb93b6-90f4-455e-b7c5-d975711ef78d";
export const RISK_SUMMARY_TYPE_SCENARIO_ID =
  "49488785-b7ab-4d29-b8f7-80ebc13f59f0";
export const RISK_SUMMARY_TYPE_MARITIME_ID =
  "81d2341f-d298-458e-aeee-4198033a3ed5";

const MARITIME_RISK_RATING_SUMMARY_TYPES =
  isFeatureUnlocked("risks-maritime") && hasMaritimeAccess()
    ? [
        {
          label: "Maritime Risk",
          id: RISK_SUMMARY_TYPE_MARITIME_ID,
          riskRatingPrimary: RISK_RATING_PRIMARIES.maritime,
        },
      ]
    : [];

const CYBER_RISK_RATING_SUMMARY_TYPES = hasPlusCyberAccess()
  ? [
      {
        label: "Cyber",
        id: "ac19dbe1-cbe4-49b5-9347-356cf4b6128f",
        riskRatingPrimary: RISK_RATING_PRIMARIES.cyber,
      },
    ]
  : [];

const BASE_RISK_RATING_SUMMARY_TYPES = [
  {
    label: "Overview",
    id: RISK_SUMMARY_TYPE_OVERVIEW_ID,
    riskRatingPrimary: 1,
  },
  {
    label: "Political Risk",
    id: "05b4805c-3317-43da-a9cc-c0ab8eac40ee",
    riskRatingPrimary: RISK_RATING_PRIMARIES.political,
  },
  {
    label: "Operational Risk",
    id: "44edece2-7d99-4403-a702-11b603d7b50b",
    riskRatingPrimary: RISK_RATING_PRIMARIES.operational,
  },
  {
    label: "Security Risk",
    id: RISK_SUMMARY_TYPE_SECURITY_RISK_ID,
    riskRatingPrimary: RISK_RATING_PRIMARIES.security,
  },
]
  .concat(MARITIME_RISK_RATING_SUMMARY_TYPES)
  .concat(CYBER_RISK_RATING_SUMMARY_TYPES);

const BASE_RISK_SUMMARY_TYPES = [
  {
    label: "Profile",
    id: RISK_SUMMARY_TYPE_PROFILE_ID,
    riskRatingPrimary: null,
  },
  {
    label: "Scenarios",
    id: RISK_SUMMARY_TYPE_SCENARIO_ID,
    riskRatingPrimary: null,
  },
];

const GRD_RISK_SUMMARY_TYPES = [
  {
    label: "Security Risk",
    id: RISK_SUMMARY_TYPE_SECURITY_RISK_ID,
    riskRatingPrimary: RISK_RATING_PRIMARIES.security,
  },
  {
    label: "Profile",
    id: RISK_SUMMARY_TYPE_PROFILE_ID,
    riskRatingPrimary: null,
  },
];

export const RISK_SUMMARY_TYPES = hasGrdAccess()
  ? GRD_RISK_SUMMARY_TYPES
  : BASE_RISK_RATING_SUMMARY_TYPES.concat(BASE_RISK_SUMMARY_TYPES);
